import React, { useDeferredValue, useState } from "react";
import { Combobox, ComboboxButton, ComboboxInput, Label } from "@headlessui/react";
import { ChevronsUpDown } from "lucide-react";
import { filterItems, isNoResultOption, SelectListOptions, toVirtualOptions } from "./select/selectListOptions";
import { FIELD_CLASS, FIELD_LABEL_CLASS } from "./fieldClass";
export const SelectMultiple = ({ items, value, onChange, title, inputRef, disabled = false }) => {
    const [search, setSearch] = useState("");
    const deferredSearch = useDeferredValue(search);
    // Names come from items, not the filtered list, so a selected value keeps its label while searching.
    const itemMap = new Map(items.map((i) => [i.value, i.name]));
    // Derived, not state — an effect lagged a render and flashed an empty list on first paint.
    const filteredList = filterItems(items, deferredSearch);
    const getName = (values) => {
        if (search !== "" || !values?.length)
            return "";
        return values
            .map((v) => itemMap.get(v) ?? "")
            .filter(Boolean)
            .join(", ");
    };
    return (<Combobox value={value} virtual={{ options: toVirtualOptions(filteredList), disabled: isNoResultOption }} onChange={(newValues) => {
            // Same HeadlessUI 2.2.9 sentinel bug as Select — appends undefined, which got saved as null.
            if (newValues.some((v) => v === undefined))
                return;
            onChange(newValues);
        }} multiple immediate disabled={disabled}>
            <div className="relative mt-1">
                {title && <Label className={FIELD_LABEL_CLASS}>{title}</Label>}
                <div className="relative w-full rounded-xl text-left">
                    <ComboboxInput className={`${FIELD_CLASS} truncate pr-9`} displayValue={(item) => getName(item)} onChange={(event) => setSearch(event.target.value)} ref={inputRef}/>

                    <div className="absolute inset-y-0 right-0 flex items-center pr-1.5">
                        <ComboboxButton className={"rounded-lg p-1 text-gray-400 hover:text-brand-600 cursor-pointer pressable focus-ring tap-target"}>
                            <ChevronsUpDown className="h-4 w-4" aria-hidden="true"/>
                        </ComboboxButton>
                    </div>
                </div>

                <SelectListOptions search={deferredSearch} setSearch={setSearch} items={items}/>
            </div>
        </Combobox>);
};
//# sourceMappingURL=selectMultiple.jsx.map